import { initialState } from "./state"

export default {
  setPlanUuidEditing: (state, payload) => (state.planUuidEditing = payload),
  setPlanAlreadyFetchEditing: (state, payload) =>
    (state.planAlreadyFetchEditing = payload),
  setPlanName: (state, payload) => (state.planName = payload),
  setPlanCommercialName: (state, payload) => (state.planCommercialName = payload),
  setPlanCategoriesOptions: (state, payload) =>
    (state.planCategoriesOptions = payload),
  setPlanCategorySelected: (state, payload) =>
    (state.planCategorySelected = payload),
  setPlanPrice: (state, payload) => (state.planPrice = payload),
  setPlanMovementsOptions: (state, payload) =>
    (state.planMovementsOptions = payload),
  setPlanMovementSelected: (state, payload) =>
    (state.planMovementSelected = payload),
  setPlanScore: (state, payload) => (state.planScore = payload),
  setPlanPhysicalPerson: (state, payload) =>
    (state.planPhysicalPerson = payload),
  setPlanLegalPerson: (state, payload) => (state.planLegalPerson = payload),
  setPlanActive: (state, payload) => (state.planActive = payload),
  setPlanRecommended: (state, payload) => (state.planRecommended = payload),
  setPlanShouldBeDisplayed: (state, payload) => (state.planShouldBeDisplayed = payload),
  setPlanIcon: (state, payload) => (state.planIcon = payload),
  setPlanIconPreview: (state, payload) => (state.planIconPreview = payload),
  setPlanRelatedPackages: (state, payload) =>
    (state.planRelatedPackages = payload),
  setPlanCreatedThrough: (state, payload) => (state.planCreatedThrough = payload),

  setPlanSvasOptions: (state, payload) => (state.planSvasOptions = payload),
  setPlanSvasSelecteds: (state, payload) => (state.planSvasSelecteds = payload),

  setPlanCampaignOptions: (state, payload) =>
    (state.planCampaignOptions = payload),
  setPlanCampaignSelecteds: (state, payload) =>
    (state.planCampaignSelecteds = payload),

  setPlanCoverageOptions: (state, payload) =>
    (state.planCoverageOptions = payload),
  updatePlanCoverageOption(state, payload) {
    state.planCoverageOptions[payload.index][payload.prop] = payload.newValue
  },

  setPlanCoverageStateOptions: (state, payload) =>
    (state.planCoverageStateOptions = payload),
  setPlanCoverageStatesSelecteds: (state, payload) =>
    (state.planCoverageStatesSelecteds = payload),
  addNewPlanCoverageStatesSelecteds(state, valueStateSelected) {
    const NEW_STATE_SELECTED = state.planCoverageStateOptions.find(
      stateOption => stateOption.value === valueStateSelected
    )
    state.planCoverageStatesSelecteds.push(NEW_STATE_SELECTED)
  },
  deletePlanCoverageStatesSelecteds(state, index) {
    state.planCoverageStatesSelecteds.splice(index, 1)
  },
  updatePricePlanCoverageStatesSelecteds(state, { index, newPrice }) {
    state.planCoverageStatesSelecteds[index].price = newPrice
  },
  togglePlanCoverageStateOptionsDisabled(state, valueStateSelected) {
    const INDEX_STATE_OPTION = state.planCoverageStateOptions.findIndex(
      stateOption => stateOption.value === valueStateSelected
    )
    state.planCoverageStateOptions[INDEX_STATE_OPTION].disabled =
      !state.planCoverageStateOptions[INDEX_STATE_OPTION].disabled
  },

  setPlanCoverageCityStateOptions: (state, payload) =>
    (state.planCoverageCityStateOptions = payload),
  setPlanCoverageCityStateSelected: (state, payload) =>
    (state.planCoverageCityStateSelected = payload),
  setPlanCoverageCityOptions: (state, payload) =>
    (state.planCoverageCityOptions = payload),
  setPlanCoverageCitySelecteds: (state, payload) =>
    (state.planCoverageCitySelecteds = payload),
  addNewPlanCoverageCitySelecteds(state, valueCitySelected) {
    const NEW_CITY_SELECTED = state.planCoverageCityOptions.find(
      cityOption => cityOption.value === valueCitySelected
    )
    state.planCoverageCitySelecteds.push(NEW_CITY_SELECTED)
  },
  deletePlanCoverageCitySelecteds(state, index) {
    state.planCoverageCitySelecteds.splice(index, 1)
  },
  updatePricePlanCoverageCitySelecteds(state, { index, newPrice }) {
    state.planCoverageCitySelecteds[index].price = newPrice
  },
  togglePlanCoverageCityOptionsDisabled(state, valueCitySelected) {
    const INDEX_CITY_OPTION = state.planCoverageCityOptions.findIndex(
      cityOption => cityOption.value === valueCitySelected
    )

    if (INDEX_CITY_OPTION >= 0) {
      state.planCoverageCityOptions[INDEX_CITY_OPTION].disabled =
        !state.planCoverageCityOptions[INDEX_CITY_OPTION].disabled
    }
  },

  setPlanCoverageDddOptions: (state, payload) =>
    (state.planCoverageDddOptions = payload),
  setPlanCoverageDddsSelecteds: (state, payload) =>
    (state.planCoverageDddsSelecteds = payload),
  addNewPlanCoverageDddsSelecteds(state, valueDddSelected) {
    const NEW_DDD_SELECTED = state.planCoverageDddOptions.find(
      chainOption => chainOption.value === valueDddSelected
    )
    state.planCoverageDddsSelecteds.push(NEW_DDD_SELECTED)
  },
  deletePlanCoverageDddsSelecteds(state, index) {
    state.planCoverageDddsSelecteds.splice(index, 1)
  },
  togglePlanCoverageDddOptionsDisabled(state, valueDddSelected) {
    const INDEX_DDD_OPTION = state.planCoverageDddOptions.findIndex(
      chainOption => chainOption.value === valueDddSelected
    )
    state.planCoverageDddOptions[INDEX_DDD_OPTION].disabled =
      !state.planCoverageDddOptions[INDEX_DDD_OPTION].disabled
  },
  updatePricePlanCoverageDddsSelecteds(state, { index, newPrice }) {
    state.planCoverageDddsSelecteds[index].price = newPrice
  },

  setPlanDiscountOptions: (state, payload) =>
    (state.planDiscountOptions = payload),
  updatePlanDiscountOption(state, payload) {
    state.planDiscountOptions[payload.index][payload.prop] = payload.newValue
  },
  setPlanDiscountTypes: (state, payload) => state.planDiscountTypes = payload,

  setPlanDiscountPaymentOptions: (state, payload) =>
    (state.planDiscountPaymentOptions = payload),
  setPlanDiscountPaymentSelecteds: (state, payload) =>
    (state.planDiscountPaymentSelecteds = payload),
  addNewPlanDiscountPaymentSelecteds(state, paymentSelected) {
    const NEW_PAYMENT_SELECTED = state.planDiscountPaymentOptions.find(
      paymentOption => paymentOption.value === paymentSelected
    )
    state.planDiscountPaymentSelecteds.push(NEW_PAYMENT_SELECTED)
  },
  deletePlanDiscountPaymentSelecteds(state, index) {
    state.planDiscountPaymentSelecteds.splice(index, 1)
  },
  togglePlanDiscountPaymentOptionsDisabled(state, paymentSelected) {
    const INDEX_PAYMENT_OPTION = state.planDiscountPaymentOptions.findIndex(
      paymentOption => paymentOption.value === paymentSelected
    )
    state.planDiscountPaymentOptions[INDEX_PAYMENT_OPTION].disabled =
      !state.planDiscountPaymentOptions[INDEX_PAYMENT_OPTION].disabled
  },
  updatePricePlanDiscountPaymentSelecteds(state, { index, newPrice }) {
    state.planDiscountPaymentSelecteds[index].price = newPrice
  },

  setPlanDiscountShippingOptions: (state, payload) =>
    (state.planDiscountShippingOptions = payload),
  setPlanDiscountShippingSelecteds: (state, payload) =>
    (state.planDiscountShippingSelecteds = payload),
  addNewPlanDiscountShippingSelecteds(state, shippingSelected) {
    const NEW_SHIPPING_SELECTED = state.planDiscountShippingOptions.find(
      shippingOption => shippingOption.value === shippingSelected
    )
    state.planDiscountShippingSelecteds.push(NEW_SHIPPING_SELECTED)
  },
  deletePlanDiscountShippingSelecteds(state, index) {
    state.planDiscountShippingSelecteds.splice(index, 1)
  },
  togglePlanDiscountShippingOptionsDisabled(state, shippingSelected) {
    const INDEX_SHIPPING_OPTION = state.planDiscountShippingOptions.findIndex(
      shippingOption => shippingOption.value === shippingSelected
    )
    state.planDiscountShippingOptions[INDEX_SHIPPING_OPTION].disabled =
      !state.planDiscountShippingOptions[INDEX_SHIPPING_OPTION].disabled
  },
  updatePricePlanDiscountShippingSelecteds(state, { index, newPrice }) {
    state.planDiscountShippingSelecteds[index].price = newPrice
  },

  setPlanAccessOptions: (state, payload) => (state.planAccessOptions = payload),
  updatePlanAccessOption(state, payload) {
    state.planAccessOptions[payload.index][payload.prop] = payload.newValue
  },

  setPlanAccessChainOptions: (state, payload) =>
    (state.planAccessChainOptions = payload),
  setPlanAccessChainsSelecteds: (state, payload) =>
    (state.planAccessChainsSelecteds = payload),
  addNewPlanAccessChainsSelecteds(state, valueChainSelected) {
    const NEW_CHAIN_SELECTED = state.planAccessChainOptions.find(
      chainOption => chainOption.value === valueChainSelected
    )
    state.planAccessChainsSelecteds.push(NEW_CHAIN_SELECTED)
  },
  deletePlanAccessChainsSelecteds(state, index) {
    state.planAccessChainsSelecteds.splice(index, 1)
  },
  togglePlanAccessChainOptionsDisabled(state, valueChainSelected) {
    const INDEX_CHAIN_OPTION = state.planAccessChainOptions.findIndex(
      chainOption => chainOption.value === valueChainSelected
    )
    state.planAccessChainOptions[INDEX_CHAIN_OPTION].disabled =
      !state.planAccessChainOptions[INDEX_CHAIN_OPTION].disabled
  },
  setPlanAccessPosOptions: (state, payload) =>
    (state.planAccessPosOptions = payload),
  setPlanAccessPosSelecteds: (state, payload) =>
    (state.planAccessPosSelecteds = payload),
  addNewPlanAccessPosSelecteds(state, valuePosSelected) {
    const NEW_POS_SELECTED = state.planAccessPosOptions.find(
      posOption => posOption.value === valuePosSelected
    )
    state.planAccessPosSelecteds.push(NEW_POS_SELECTED)
  },
  deletePlanAccessPosSelecteds(state, index) {
    state.planAccessPosSelecteds.splice(index, 1)
  },
  togglePlanAccessPosOptionsDisabled(state, valuePosSelected) {
    const INDEX_POS_OPTION = state.planAccessPosOptions.findIndex(
      posOption => posOption.value === valuePosSelected
    )
    state.planAccessPosOptions[INDEX_POS_OPTION].disabled =
      !state.planAccessPosOptions[INDEX_POS_OPTION].disabled
  },

  setHasAdditionalConfig: (state, payload) => (state.hasAdditionalConfig = payload),
  setFreeAdditionalQuantity: (state, payload) => (state.freeAdditionalQuantity = payload),
  setPaidAdditionalQuantity: (state, payload) => (state.paidAdditionalQuantity = payload),
  setAdditionalUnitPrice: (state, payload) => (state.additionalUnitPrice = payload),


  resetPlan: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
